import { MarkierungType } from '@/domain/termine/shared/types/Markierung';
export class TerminKalender {
  id: string;
  name: string;
  kalenderSchluessel?: number;
  idStandort?: string;
  markierung?: MarkierungType;

  constructor(data: {
    id: string;
    name: string;
    kalenderSchluessel?: number;
    idStandort?: string;
    markierung?: MarkierungType;
  }) {
    this.id = data.id;
    this.name = data.name;
    this.kalenderSchluessel = data.kalenderSchluessel;
    this.idStandort = data.idStandort;
    this.markierung = data.markierung;
  }
}
